import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
import { isNull, isNullOrUndefined } from "util"; // eslint-disable-line no-unused-vars
export default {
  computed: {
    userProfiles: get("authentication/userProfiles"),
    user: get("authentication/user"),
    userPromotion: get("authentication/userPromotion"),
    systemParametersRetrive: get("systemParameters/systemParametersResult")
  },
  data() {
    return {
      profileComponentsMap: new Map()
    }
  },
  methods: {
    buildComponentsMap() {
      var vm = this;
      return new Promise((resolve, reject) => {
        vm.profileComponentsMap = new Map();
        if (vm.userProfiles) {
          for (var i = 0; i < vm.userProfiles.length; i++) {
            for (var j = 0; j < vm.userProfiles[i].components.length; j++) {
              var component = vm.userProfiles[i].components[j];
              vm.profileComponentsMap.set(component.identification, component.identification)
            }
          }
        }
        resolve(vm.profileComponentsMap);
        if (!vm.profileComponentsMap) {
          reject(
            vm.$notify.error({
              title: vm.i18nValues["error"],
              position: "bottom-right",
              duration: 7000
            })
          );
        }
      });
    },
    promotionAuth: function (promotion) {
      var vm = this;
      let categorySupervisor = null;
      let categoryAdministrador = null;
      if (promotion.creator != null) {
        for (let i = 0; i < vm.userProfiles.length; i++) {
          vm.userProfiles[i].category == 'Administrador' ? categoryAdministrador = vm.userProfiles[i] : null
          vm.userProfiles[i].category == 'Supervisor' ? categorySupervisor = vm.userProfiles[i] : null
        }
        // 1.1 Es el usuario creador + componente.
        if (promotion.creator.userId === vm.user.userId) {
          return true;
        }
        // 1.4 Es un usuario con perfil cuya user_category = administrador + componente
        else if (categoryAdministrador != null) {
          return true;
        }
        // 1.2 Es un usuario con mismo perfil que el creador + componente + parámetro 97 = true. 
        else if (vm.arrayContainsArray(vm.userProfiles, promotion.creator.profiles) && vm.systemParametersRetrive['SYS_PAR_UM_OPERATOR_TEMPLATE_ACCESS'].value == 'true') {
          return true;
        }
        // 1.3 Es un usuario con perfil cuya user_category = supervisor + componente + 1 de las dos siguientes.
        else if (categorySupervisor != null) {
          // 1.3.1 Su perfil esta en la lista Supervised By del perfil del creador de la promo
          if (vm.arrayContainsArray(categorySupervisor.supervisedBy, promotion.creator.profiles)) {
            return true;
          }
          // 1.3.2 Su perfil esta en la lista de Promotion_Profiles (ver punto 5) asociado a la promo (si esta esta vacía, se toma la lista de template_profiles).
          // Si la promoción no fue creada con template, solo será valida la condición anterior 1.3.1
          else if (promotion.createFromTemplate == '1') { // fue creada por un template
            if (promotion.promotionProfiles.length != 0) {
              if (vm.arrayContainsArray(vm.userProfiles, promotion.promotionProfiles)) {
                return true;
              } else {
                return false;
              }
            } else if (vm.arrayContainsArray(vm.userProfiles, promotion.templateProfiles)) {
              return true;
            } else {
              return false;
            }
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    templateAuth: function (template) {
      var vm = this;
      if (vm.arrayContainsArray(vm.userProfiles, template.profiles)) {
        return true;
      } else {
        return false;
      }
    },
    hasComponent: function (componentIdentification) {
      if (!this.userProfiles) {
        return false;
      }
      for (var i = 0; i < this.userProfiles.length; i++) {
        for (var j = 0; j < this.userProfiles[i].components.length; j++) {
          var component = this.userProfiles[i].components[j];
          if (component.identification == componentIdentification) {
            return true;
          }
        }
      }
      return false;
    },
    arrayContainsArray(superset, subset) {
      let ret = false
      for (let i = 0; i < subset.length; i++) {
        superset.some(ele => ele.id == subset[i].id) ? ret = true : ret = false
      }
      return ret;
    },
  }
};
